import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import styled from 'styled-components';
import CompareCheckbox from '../CompareCheckbox/CompareCheckbox';
import ProductChannelsAvailability from '../ProductChannelsAvailability/ProductChannelsAvailability';
import {
  showFlexibleCreditTooltip,
  hideFlexibleCreditTooltip
} from '../../reduck/listingPageCommonData.reduck';
import { getTranslation } from '../../translations/translations';

import ProductBriefDescriptionSwitch from '../ProductBriefDescriptonSwitch/ProductBriefDescriptionSwitch';
import GridItemTopImageAndBadges from './GridItemTopImageAndBadges/GridItemTopImageAndBadges';
import GridItemCountdownLabels from './GridItemCountdownLabels/GridItemCountdownLabels';
import GridItemOutfitsInfo from './GridItemOutfitsInfo/GridItemOutfitsInfo';
import ProductItemReviewInfo from '../ProductItemReviewInfo/ProductItemReviewInfo';
import GridItemPromoMessages from './GridItemPromoMessages/GridItemPromoMessages';
import ProductItemDescriptionBullets from '../ProductItemDescriptionBullets/ProductItemDescriptionBullets';
import ProductItemPriceBlock from '../ProductItemPriceBlock/ProductItemPriceBlock';
import ProductItemOnlineCreditInfo from '../ProductItemOnlineCreditInfo/ProductItemOnlineCreditInfo';
import GridItemCountdownMessage from './GridItemCountdownMessage/GridItemCountdownMessage';
import ProductItemTitle from '../ProductItemTitle/ProductItemTitle';
import SponsoredProductBeacon from '../SponsoredProductBeacon/SponsoredProductBeacon';
import { Product } from '../Product/Product';

const Link = styled.a`
  text-decoration: inherit;
  color: inherit;
  text-decoration: none;
`;

const OnlineCreditMessageWrapper = styled.div`
  position: relative;
`;

const mediaTabletLarge = 'only screen and (min-width: 769px) and (max-width: 1024px)';

const mediaTabletSmall = 'only screen and (min-width: 600px) and (max-width: 768px)';

const DivWrapper = styled(Product)`

  .compare {
    position: static;
    width: auto;
    text-align: left;
    margin: 0 5px;
    color: #666;
    display: block;
    white-space: nowrap;

    input {
      vertical-align: middle;
    }

    @media ${({ theme }) => theme.breakpoints.mobile} {
      display: none;
    }
  }

  display: block;

  .desc {
    &:before {
      display: none;
    }

    .in {
      display: block;
    }
  }

  .promoMessages {
    margin: 10px 0;

    .rad {
      margin-bottom: 5px;
      color: #000;
      text-transform: none;

      > div {
        margin: 3px 0;
      }

      @media ${({ theme }) => theme.breakpoints.tablet}, ${({ theme }) => theme.breakpoints.mobile} {
        font-size: 14px;
      }
    }
  }

  .reevoo-placeholder {
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
  }

  .reevoo-score {
    margin-top: -4px;
  }

  .promoMessages {
    width: 100%;
    box-sizing: border-box;
    line-height: 22px;
    color: #a21411;
    border-color: #a21411;
    border-width: 2px;
    text-align: center;
    text-transform: lowercase;
  }

  .productPrices {
    width: auto !important;
    margin: 10px 0;

    .amounts {
      margin-bottom: 0;
    }

    .main-amount {
      margin-bottom: 0;
      padding: 8px 0;
    }

    .price {
      display: block;
      font-size: 16px;
      margin-bottom: 3px;
    }

    .tariff-price {
      display: inline;
      font-size: 16px;
      margin-bottom: 3px;
    }

    .prd-oos .price,
    .prd-oos .tariff-price,
    .prd-oos .per-month,
    .prd-oos .saving {
      color: #a9a9a9;
    }

    .saving {
      font-size: 12px;
      padding: 0;
      @media ${({ theme }) => theme.breakpoints.desktop} {
        text-transform: lowercase;
      }
    }

    .past-amount {
      font-size: 12px;
      @media ${({ theme }) => theme.breakpoints.mobile} {
        display: none;
      }
    }
  }

  .countdownMessage {
    text-align: center;
  }

  &.product {
    width: 25%;
    box-sizing: border-box;
    display: inline-block;
    padding: 0 12px 3px 12px;
    margin: 24px 0;
    vertical-align: top;
    overflow: visible;
    border: 1px solid transparent;
    border-right: 1px solid #e5e5e5; 

    &:before {
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      left: 10px;
      right: 10px;
      top: -26px;
      background: #e5e5e5;
    }

    &:hover:not(.wrapper-sponsored) {
      border: 1px solid #4855a0;
    }

    @media ${({ theme }) => theme.breakpoints.desktop}, ${mediaTabletLarge} {
      &:nth-of-type(4n):not(.wrapper-sponsored):not(:hover) {
        border: 1px solid transparent;
      }

      // 1, 5, 9, 13 ... has border on the left because it's on the beginning of the row when there are 4 products in row
      &:nth-of-type(4n + 1).wrapper-sponsored {
        border-left: 1px solid #999;
      }
    }

    @media ${mediaTabletSmall} {
      width: 33.333%;

      &:nth-of-type(3n):not(.wrapper-sponsored):not(:hover) {
        border: 1px solid transparent;
      }

      // 1, 4, 7, 10 ... has border on the left because it's on the beginning of the row when there are 3 products in row
      &:nth-of-type(3n + 1).wrapper-sponsored {
        border-left: 1px solid #999;
      }

      // set top border of fourth wrapper-sponsored product to color of the background
      // when there are 3 products in row
      &.wrapper-sponsored:nth-of-type(7) {
        border-top-color: #f1f1f1;
      }
    }

    @media ${({ theme }) => theme.breakpoints.mobile} {
      width: 50%;

      &:nth-of-type(2n):not(.wrapper-sponsored):not(:hover) {
        border: 1px solid transparent;
      }

      // 1, 3, 5, 7 ... has border on the left because it's on the beginning of the row when there are 2 products in row
      &:nth-of-type(2n + 1).wrapper-sponsored {
        border-left: 1px solid #999;
      }

      // set top border of the third and fourth wrapper-sponsored product to color of the background
      // when there are 2 products in row
      &.wrapper-sponsored:nth-of-type(7),
      &.wrapper-sponsored:nth-of-type(8) {
        border-top-color: #f1f1f1;
      }
    }
  }

  .hero-product {
    overflow: visible;

    .label-expert {
      top: -9px;
      left: -5px;
      right: -5px;
      height: auto;
      width: 100%;
      background: none;
      text-align: center;
      position: absolute;

      .resultGrid & {
        position: absolute;
        top: -14px;
        z-index: 1;
        display: block;
        width: auto;
        border-top: 1px solid #4855a0;
        margin: 0 10px -18px;

        div:before,
        div:after {
          content: '';
          display: block;
          position: absolute;
          width: 2px;
          height: 3px;
          background: #161b7a;
        }

        div {
          display: table;
          margin-top: -10px;

          &:before,
          &:after {
            top: 0;
          }

          &:before {
            left: 0;
          }

          &:after {
            right: 0;
          }
        }
      }

      div {
        padding-left: 5px;
        padding-right: 5px;
        display: inline-block;
        color: #4855a0;
        background: white;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  &.wrapper-sponsored {
    margin: 0;
    padding: 24px 12px 29px;
    z-index: 1;
    border-top: 1px solid #999;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;

    &.product {
      &:hover:not(.sponsored) {
        border: 1px solid inherit;
      }
    }

    &:before {
      content: none;
    }

    &:after {
      content: none;
    }

    .sponsoredLabel {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding-top: 2px;
      padding-bottom: 2px;
      text-align: center;
      font-size: 13px;
      background-color: #f1f1f1;
      border-bottom: 1px solid #e5e5e5;
    }
  }
`;

class ProductGridItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onView: null
    };
  }

  getSupportedOnlineCreditSpecialOfferType(stickerImage) {
    if (stickerImage?.alt?.match(/bnpl/gi)) {
      // product supports 'buy now and pay later' special credit offer type
      return 'BNPL';
    }

    if (stickerImage?.alt?.match(/ifc/gi)) {
      // product supports 'interest free credit' special credit offer type
      return 'IFC';
    }

    // product supports no special credit offer type
    return undefined;
  }

  renderProductContent() {
    const {
      hasOurExpertsLoveTag,
      sponsored,
      link,
      image,
      icons,
      loadImages,
      stickerImage,
      id,
      isFlashSale,
      countdownClassSuffix,
      brand,
      title,
      comboKitItemsNames,
      review,
      promoMessages,
      preOrder,
      descriptionBullets,
      defaultChannelsAvailability,
      price,
      isOnlineCreditAvailable,
      deviceType,
      priceForOnlineCredit,
      showCreditTooltip,
      hideCreditTooltip,
      gridItemRowLocation,
      openedCreditTooltipProductID,
      placeSpecificChannelsAvailability,
      displayCompare
    } = this.props;

    const supportedOnlineCreditSpecialOfferType = this.getSupportedOnlineCreditSpecialOfferType(
      stickerImage
    );

    return (
      <>
        {hasOurExpertsLoveTag && (
          <strong className={'label-expert'}>
            <div>{getTranslation('ourExpertsLoveTranslation')}</div>
          </strong>
        )}
        {sponsored && <div className={'sponsoredLabel'}>Sponsored</div> /* Add to translations */}
        <GridItemTopImageAndBadges
          link={link}
          image={image}
          icons={icons}
          loadImages={loadImages}
          stickerImage={stickerImage}
        />
        <div className={'desc'}>
          <Link className={'in'} href={link}>
            <GridItemCountdownLabels
              id={id}
              isFlashSale={isFlashSale}
              countdownClassSuffix={countdownClassSuffix}
            />
            <ProductItemTitle brand={brand} title={title} />
            <GridItemOutfitsInfo comboKitItemsNames={comboKitItemsNames} />
            <ProductItemReviewInfo review={review} />
            <GridItemPromoMessages
              promoMessages={promoMessages}
              preOrder={preOrder}
              loadImages={loadImages}
            />
            <ProductItemDescriptionBullets descriptionBullets={descriptionBullets} />
            <div className={'productPrices'}>
              <ProductItemPriceBlock
                defaultChannelsAvailability={defaultChannelsAvailability}
                price={price}
                isFlashSale={isFlashSale}
                variant={'listing_grid'}
              />
            </div>
            <OnlineCreditMessageWrapper className={'online-credit-message-wrapper'}>
              {isOnlineCreditAvailable && (
                <ProductItemOnlineCreditInfo
                  productID={id}
                  specialCreditOfferType={supportedOnlineCreditSpecialOfferType}
                  productPriceWithoutCurrencySign={priceForOnlineCredit}
                  deviceType={deviceType}
                  openedCreditTooltipProductID={openedCreditTooltipProductID}
                  showCreditTooltip={showCreditTooltip}
                  hideCreditTooltip={hideCreditTooltip}
                  gridItemRowLocation={gridItemRowLocation}
                />
              )}
            </OnlineCreditMessageWrapper>
            <GridItemCountdownMessage isFlashSale={isFlashSale} />
            <ProductChannelsAvailability
              defaultChannelsAvailability={defaultChannelsAvailability}
              placeSpecificChannelsAvailability={placeSpecificChannelsAvailability}
              id={id}
            />
          </Link>
          <ProductBriefDescriptionSwitch productID={id} withArrow />
          {!!deviceType && displayCompare && (
            <CompareCheckbox productId={id} tooltipArrowDirection={'top'} />
          )}
        </div>
      </>
    );
  }

  render() {
    const {
      stickerImage,
      hasOurExpertsLoveTag,
      defaultChannelsAvailability,
      sponsored,
      beacons,
      id,
      dataInteraction,
      onGetToViewport
    } = this.props;

    const classes = ['product'];

    if (stickerImage) {
      classes.push('stamped');
    }

    if (hasOurExpertsLoveTag) {
      classes.push('hero-product');
    }

    if (defaultChannelsAvailability.canBeDownloaded) {
      classes.push('download');
    }

    if (sponsored) {
      classes.push('sponsored');
    }

    return (
      <DivWrapper className={`product ${sponsored ? 'wrapper-sponsored' : ''}`}>
        <InView
          className={classes.join(' ')}
          id={`id${id}${sponsored ? '-sponsored' : ''}`}
          as={'article'}
          onChange={(inView, entry) => {
            if (inView) {
              if (sponsored && beacons?.onView) {
              // when product is sponsored we need to add beacon img element when user have the product in view on his display
                this.setState({
                  onView: beacons.onView
                });
              }

              onGetToViewport();
            }
          }}
          triggerOnce
          data-interaction={dataInteraction}
          data-fupid={dataInteraction ? id : undefined}
        >
          {this.renderProductContent()}
          {
          // when product is sponsored we need to add beacon img element when user have the product in view on his display
          sponsored && beacons?.onView && this.state.onView ? (
            <SponsoredProductBeacon
              className={'sponsored-product-beacon'}
              src={this.state.onView}
              alt={'beacon'}
            />
          ) : null
        }
        </InView>

      </DivWrapper>
    );
  }
}

ProductGridItem.displayName = 'ProductGridItem';

ProductGridItem.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  defaultChannelsAvailability: PropTypes.shape({
    canBeDownloaded: PropTypes.bool,
    showEmailMeBack: PropTypes.bool,
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }).isRequired,
  placeSpecificChannelsAvailability: PropTypes.shape({
    canBeDownloaded: PropTypes.bool,
    showEmailMeBack: PropTypes.bool,
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }),
  comboKitItemsNames: PropTypes.arrayOf(PropTypes.string),
  comboKitNumberOfItemsMessage: PropTypes.string,
  countdownClassSuffix: PropTypes.string,
  displayCompare: PropTypes.bool.isRequired,
  deviceType: PropTypes.string,
  openedCreditTooltipProductID: PropTypes.string,
  hasOurExpertsLoveTag: PropTypes.bool.isRequired,
  isFlashSale: PropTypes.bool.isRequired,
  isOnlineCreditAvailable: PropTypes.bool,
  priceForOnlineCredit: PropTypes.number,
  brand: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  descriptionShortened: PropTypes.string.isRequired,
  descriptionBullets: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({
    currentPrice: PropTypes.string.isRequired,
    savingsPrice: PropTypes.string,
    wasPrice: PropTypes.string
  }).isRequired,
  link: PropTypes.string.isRequired,
  promoMessages: PropTypes.shape({
    dealsAvailable: PropTypes.arrayOf(PropTypes.object),
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(
      PropTypes.shape({
        class: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      }).isRequired
    ),
    badges: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        src: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  preOrder: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    message: PropTypes.string
  }).isRequired,
  gridItemRowLocation: PropTypes.oneOf(['left', 'middle', 'right']).isRequired,
  review: PropTypes.shape({
    reviewCount: PropTypes.number.isRequired,
    score: PropTypes.number
  }),
  showCreditTooltip: PropTypes.func,
  hideCreditTooltip: PropTypes.func,
  stickerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  loadImages: PropTypes.bool,
  onGetToViewport: PropTypes.func,
  dataInteraction: PropTypes.string,
  sponsored: PropTypes.bool,
  beacons: PropTypes.shape({
    onView: PropTypes.string
  })
};

ProductGridItem.defaultProps = {
  icons: undefined,
  placeSpecificChannelsAvailability: undefined,
  comboKitItemsNames: undefined,
  comboKitNumberOfItemsMessage: undefined,
  countdownClassSuffix: undefined,
  deviceType: undefined,
  isOnlineCreditAvailable: false,
  priceForOnlineCredit: undefined,
  review: undefined,
  stickerImage: undefined,
  loadImages: false,
  openedCreditTooltipProductID: null,
  showCreditTooltip: () => {},
  hideCreditTooltip: () => {},
  onGetToViewport: () => {},
  dataInteraction: undefined,
  sponsored: false,
  beacons: null
};

const mapStateToProps = (state) => ({
  openedCreditTooltipProductID: state.listingPage.commonData.flexibleCreditTooltipProductID,
  deviceType: state.listingPage.browser ? state.listingPage.browser.device.deviceType : undefined
});

const dispatchFunctions = {
  showCreditTooltip: showFlexibleCreditTooltip,
  hideCreditTooltip: hideFlexibleCreditTooltip
};

// forwardRef is here for recalculating grid items heights
export default connect(mapStateToProps, dispatchFunctions, null, { forwardRef: true })(
  ProductGridItem
);
